export interface JudgementOnMeritsDoc {
  url: string;
  type: string;
  name: string;
}
export const JUDGEMENT_EXPERTISE_TYPES = {
  CIVIL: 'CIVIL',
  NON_COMPENSATION: 'NON_COMPENSATION',
  CIVIL_AND_NON_COMPENSATION: 'CIVIL_AND_NON_COMPENSATION',
};
export const MODE_TYPES = {
  FORM: 'FORM',
  RECAP: 'RECAP',
};
export const CIVIL_JUDGEMENT_MECHANICAL_EXPERTISE = 'civjmece';
export const DAMAGE_AMOUNT = 'damageAmount';
export const PROVISION_EXECUTION = 'provisionalExecution';
export const CIVIL_JUDGEMENT_MEDICAL_EXPERTISE = 'civjmede';
export const CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE = 'civjacce';
export const JUDGEMENT_ON_MERITS = 'jom';
export const CIVIL_JUDGEMENTS = 'civjs';
export const CIVIL_JUDGEMENTS_VICTIM = 'civjvm';
export const CIVIL_JUDGEMENT = {
  VICTIM_CIVIL_JUDGEMENT: 'victimCivilJudgement',
  VEHICLE_CIVIL_JUDGEMENT: 'vehicleCivilJudgement',
  CIVIL_JUDGEMENT_VICTIM_RECAP: 'civilJudgementVictimRecap',
  CIVIL_JUDGEMENT_VEHICLE_RECAP: 'civilJudgementVehicleRecap',
  SUBSTANTIVE_REJECTION_RECAP: 'substantiveRejectionRecap',
  FORM_REJECTION_RECAP: 'formRejectionRecap',
  FORM_REJECTION: 'formRejection',
  SUBSTANTIVE_REJECTION: 'substantiveRejection',
};
export const CIVIL_JUDGEMENT_TYPES = {
  CIVIL_JUDGEMENT: 'CIVIL_JUDGEMENT',
  FORM_REJECTION: 'FORM_REJECTION',
  SUBSTANTIVE_REJECTION: 'SUBSTANTIVE_REJECTION',
};
export const CORRECTIONAL_DOC_ID = '001';
export const CIVIL_DOC_ID = '002';
export const CONTESTATION_REQUEST_ID = '0010';
export const CONTESTATION_ACT_ID = '0011';
export const CONTESTATION_ID = '0012';
export const BENEFICIARY_JUDGEMENT = {
  COMPENSATION: 'COMPENSATION',
  FORM_REJECTION: 'FORM_REJECTION',
  SUBSTANTIVE_REJECTION: 'SUBSTANTIVE_REJECTION',
};
export const EMPTY_BENEFICIARY_JUDGEMENT = {
  [BENEFICIARY_JUDGEMENT.COMPENSATION]: false,
  [BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION]: false,
  [BENEFICIARY_JUDGEMENT.FORM_REJECTION]: false,
};

export const MEDICAL_EXPERTISE_ID = '1';
export const COMPTABLE_EXPERTISE_ID = '2';

export const MECHANICAL_EXPERTISE_ID = '3';

export const JUDGEMENT_ON_MERITS_CORRECTIONAL_CONDAMNATION =
  'jom.cj.condamnation';

export const JUDGEMENT_ON_MERITS_CORRECTIONAL_JUDGEMENT_DOCUMENT =
  'jom.cj.document';

export const JUDGEMENT_ON_MERITS_CORRECTIONAL_JUDGEMENT_CONTESTATION =
  'judgementOnMerits.jom.cj.contest';

export const JUDGEMENT_ON_MERITS_CIVIL_JUDGEMENT =
  'judgementOnMerits.jom.civjs';
export const JUDGEMENT_DATE = 'judgementOnMerits.jom.judgementDate';
export const CALCULATION_START_DATE =
  'judgementOnMerits.jom.calculationStartDate';
export const IDD = 'judgementOnMerits.jom.idd';

export const JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED = 'Oui';

export const JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED = 'Non';

export const DEFAULT_SUB_SERVICE_ID = 130;

export const DEFAULT_RC_AMOUNT = 0;

export const CIVIL_JUDGEMENT_VICTIM_FIELDS = {
  OTHER_REASON: 'otherReason',
  REASON: 'reasonId',
};

export const MAX_IPP_RATE = 50;
export const MAX_ACCOUNTING_EXPERTISE_AMOUNT = 300000;
export const MAX_PROVISION = 500000;
export const PROFESSION_CODES = ['166', '309', '55', '56', '165'];
